'use strict';

import { DynamicScriptLoader, MessageService } from '@wephone-utils';
import { NgZone, Injectable } from '@angular/core';

@Injectable()
export class SalesforceService {

  constructor(private scriptLoader: DynamicScriptLoader,
              private ngZone: NgZone,
              private messageService: MessageService
  ) {
  }

  loadCTIScript(): Promise<void> {
    const loader = this.scriptLoader.loadScript('https://smartcontact-dev-ed.lightning.force.com/support/api/45.0/lightning/opencti_min.js');
    return loader.then(
      ret => {
        const sforce = window['sforce'];
        sforce.opencti.enableClickToDial();
        sforce.opencti.onClickToDial(
          {
            listener: payload => {
              // console.log('Clicked phone number: ' + payload.number);
              this.ngZone.run(
                () => {
                  this.messageService.broadcast('phone:open_dialer', payload.number);
                }
              );
            }
          }
        );
      }
    );
  }
}
